import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface UnSaveModalState {
  showModal: boolean;
  hasUnsavedChanges: boolean;
  showAddUserModal: boolean;
  triggerLogout: boolean;
  shouldTriggerAction: boolean;
  showRGFWarningPopup: boolean;
  shouldAppendUpdateRGFMsg: boolean;
  disabledRGFLabelArray: string[];
}

const initialState: UnSaveModalState = {
  showModal: false,
  hasUnsavedChanges: true,
  showAddUserModal: false,
  triggerLogout: false,
  shouldTriggerAction: false,
  showRGFWarningPopup: false,
  shouldAppendUpdateRGFMsg: false,
  disabledRGFLabelArray: [],
};

const UnSavedChangeModalSlice = createSlice({
  name: 'unsavedchangesmodal',
  initialState,
  reducers: {
    setShowModal(state, action: PayloadAction<boolean>) {
      state.showModal = action.payload;
    },
    setHasUnsavedChanges(state, action: PayloadAction<boolean>) {
      state.hasUnsavedChanges = action.payload;
    },
    setAddUserModal(state, action: PayloadAction<boolean>) {
      state.showAddUserModal = action.payload;
    },
    setShowRGFWarningPopup: (state, action: PayloadAction<boolean>) => {
      state.showRGFWarningPopup = action.payload;
    },
    setShouldAppendUpdateRGFMsg: (state, action: PayloadAction<boolean>) => {
      state.shouldAppendUpdateRGFMsg = action.payload;
    },
    setDisabledRGFLabelArray: (state, action: PayloadAction<string[]>) => {
      state.disabledRGFLabelArray = action.payload;
    },
    setTriggerLogout: (state) => {
      state.triggerLogout = true;
    },
    setShouldTriggerAction: (state) => {
      state.shouldTriggerAction = true;
    },
    resetTrigger: (state) => {
      state.triggerLogout = false;
      state.shouldTriggerAction = false;
    },
  },
});

export const {
  setShowModal,
  setHasUnsavedChanges,
  setAddUserModal,
  setShowRGFWarningPopup,
  setShouldAppendUpdateRGFMsg,
  setDisabledRGFLabelArray,
  setTriggerLogout,
  resetTrigger,
  setShouldTriggerAction,
} = UnSavedChangeModalSlice.actions;
export default UnSavedChangeModalSlice.reducer;
